/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserAPI {

  /**
   * Method that returns a particular user
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiAdminUser(
    id: number,
  ): CancelablePromise<{
    id: number;
    agency_id: number | null;
    account_manager_id: number | null;
    analyst_id: number | null;
    lookup_countries_id: string | null;
    lookup_states_id: string | null;
    active: boolean;
    email: string;
    monitoring_emails: string | null;
    crypted_password: string | null;
    salt: string;
    hash: 'sha1' | 'sha3_512';
    password_updated_at: string;
    title: string | null;
    firstname: string | null;
    lastname: string | null;
    birth_year: number | null;
    phone: string | null;
    address_1: string | null;
    address_2: string | null;
    city: string | null;
    postalcode: string | null;
    activation_code: string | null;
    created_at: string;
    updated_at: string;
    delivery_fee_active: boolean;
    show_contracts: boolean;
    has_sales_access: boolean;
    sales_revenue_ratio: number | null;
    custom_revenue_ratio: number | null;
    company_name: string | null;
    payments_to: string | null;
    fax: string | null;
    fixed_cpm: number | null;
    language_id: string;
    order_prefix: string | null;
    gst_number: string | null;
    pst_number: string | null;
    show_zone_label: boolean;
    screen_id_prefix: string | null;
    site_name_prefix: string | null;
    demo_mode: boolean;
    notes: string | null;
    source: string | null;
    avatar: string | null;
    currency_id: string;
    time_zone_id: string;
    ui_settings: {
      theme: 'dark' | 'light';
      distance_unit: 'millimeters' | 'centimeters' | 'meters' | 'kilometers' | 'inches' | 'feet' | 'yards' | 'miles' | 'nauticalmiles';
    };
    account_manager_id2: number | null;
    dsp_id: number | null;
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/user/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that creates a new user
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiUser(
    requestBody: {
      id?: number;
      agency_id?: number | null;
      account_manager_id?: number | null;
      analyst_id?: number | null;
      lookup_countries_id?: string | null;
      lookup_states_id?: string | null;
      active?: boolean;
      email: string;
      monitoring_emails?: string | null;
      title?: string | null;
      firstname?: string | null;
      lastname?: string | null;
      birth_year?: number | null;
      phone?: string | null;
      address_1?: string | null;
      address_2?: string | null;
      city?: string | null;
      postalcode?: string | null;
      activation_code?: string | null;
      delivery_fee_active?: boolean;
      show_contracts?: boolean;
      has_sales_access?: boolean;
      sales_revenue_ratio?: number | null;
      custom_revenue_ratio?: number | null;
      company_name?: string | null;
      payments_to?: string | null;
      fax?: string | null;
      fixed_cpm?: number | null;
      language_id?: 'en' | 'es' | 'fr';
      order_prefix?: string | null;
      gst_number?: string | null;
      pst_number?: string | null;
      show_zone_label?: boolean;
      screen_id_prefix?: string | null;
      site_name_prefix?: string | null;
      demo_mode?: boolean;
      notes?: string | null;
      source?: string | null;
      avatar?: string | null;
      currency_id?: 'CAD' | 'EUR' | 'USD';
      time_zone_id?: string;
      ui_settings?: {
        theme: 'dark' | 'light';
        distance_unit: 'millimeters' | 'centimeters' | 'meters' | 'kilometers' | 'inches' | 'feet' | 'yards' | 'miles' | 'nauticalmiles';
      };
      account_manager_id2?: number | null;
      dsp_id?: number | null;
      password?: string;
    },
  ): CancelablePromise<{
    id: number;
    agency_id: number | null;
    account_manager_id: number | null;
    analyst_id: number | null;
    lookup_countries_id: string | null;
    lookup_states_id: string | null;
    active: boolean;
    email: string;
    monitoring_emails: string | null;
    crypted_password: string | null;
    salt: string;
    hash: 'sha1' | 'sha3_512';
    password_updated_at: string;
    title: string | null;
    firstname: string | null;
    lastname: string | null;
    birth_year: number | null;
    phone: string | null;
    address_1: string | null;
    address_2: string | null;
    city: string | null;
    postalcode: string | null;
    activation_code: string | null;
    created_at: string;
    updated_at: string;
    delivery_fee_active: boolean;
    show_contracts: boolean;
    has_sales_access: boolean;
    sales_revenue_ratio: number | null;
    custom_revenue_ratio: number | null;
    company_name: string | null;
    payments_to: string | null;
    fax: string | null;
    fixed_cpm: number | null;
    language_id: string;
    order_prefix: string | null;
    gst_number: string | null;
    pst_number: string | null;
    show_zone_label: boolean;
    screen_id_prefix: string | null;
    site_name_prefix: string | null;
    demo_mode: boolean;
    notes: string | null;
    source: string | null;
    avatar: string | null;
    currency_id: string;
    time_zone_id: string;
    ui_settings: {
      theme: 'dark' | 'light';
      distance_unit: 'millimeters' | 'centimeters' | 'meters' | 'kilometers' | 'inches' | 'feet' | 'yards' | 'miles' | 'nauticalmiles';
    };
    account_manager_id2: number | null;
    dsp_id: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a particular user
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiUser(
    requestBody: {
      id: number;
      agency_id?: number | null;
      account_manager_id?: number | null;
      analyst_id?: number | null;
      lookup_countries_id?: string | null;
      lookup_states_id?: string | null;
      active?: boolean;
      email?: string;
      monitoring_emails?: string | null;
      title?: string | null;
      firstname?: string | null;
      lastname?: string | null;
      birth_year?: number | null;
      phone?: string | null;
      address_1?: string | null;
      address_2?: string | null;
      city?: string | null;
      postalcode?: string | null;
      activation_code?: string | null;
      delivery_fee_active?: boolean;
      show_contracts?: boolean;
      has_sales_access?: boolean;
      sales_revenue_ratio?: number | null;
      custom_revenue_ratio?: number | null;
      company_name?: string | null;
      payments_to?: string | null;
      fax?: string | null;
      fixed_cpm?: number | null;
      language_id?: 'en' | 'es' | 'fr';
      order_prefix?: string | null;
      gst_number?: string | null;
      pst_number?: string | null;
      show_zone_label?: boolean;
      screen_id_prefix?: string | null;
      site_name_prefix?: string | null;
      demo_mode?: boolean;
      notes?: string | null;
      source?: string | null;
      avatar?: string | null;
      currency_id?: 'CAD' | 'EUR' | 'USD';
      time_zone_id?: string;
      ui_settings?: {
        theme: 'dark' | 'light';
        distance_unit: 'millimeters' | 'centimeters' | 'meters' | 'kilometers' | 'inches' | 'feet' | 'yards' | 'miles' | 'nauticalmiles';
      };
      account_manager_id2?: number | null;
      dsp_id?: number | null;
      password?: string;
      current_password?: string;
    },
  ): CancelablePromise<{
    id: number;
    agency_id: number | null;
    account_manager_id: number | null;
    analyst_id: number | null;
    lookup_countries_id: string | null;
    lookup_states_id: string | null;
    active: boolean;
    email: string;
    monitoring_emails: string | null;
    crypted_password: string | null;
    salt: string;
    hash: 'sha1' | 'sha3_512';
    password_updated_at: string;
    title: string | null;
    firstname: string | null;
    lastname: string | null;
    birth_year: number | null;
    phone: string | null;
    address_1: string | null;
    address_2: string | null;
    city: string | null;
    postalcode: string | null;
    activation_code: string | null;
    created_at: string;
    updated_at: string;
    delivery_fee_active: boolean;
    show_contracts: boolean;
    has_sales_access: boolean;
    sales_revenue_ratio: number | null;
    custom_revenue_ratio: number | null;
    company_name: string | null;
    payments_to: string | null;
    fax: string | null;
    fixed_cpm: number | null;
    language_id: string;
    order_prefix: string | null;
    gst_number: string | null;
    pst_number: string | null;
    show_zone_label: boolean;
    screen_id_prefix: string | null;
    site_name_prefix: string | null;
    demo_mode: boolean;
    notes: string | null;
    source: string | null;
    avatar: string | null;
    currency_id: string;
    time_zone_id: string;
    ui_settings: {
      theme: 'dark' | 'light';
      distance_unit: 'millimeters' | 'centimeters' | 'meters' | 'kilometers' | 'inches' | 'feet' | 'yards' | 'miles' | 'nauticalmiles';
    };
    account_manager_id2: number | null;
    dsp_id: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/user',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that deletes a particular user
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiUser(
    id: number,
  ): CancelablePromise<{
    id: number;
    agency_id: number | null;
    account_manager_id: number | null;
    analyst_id: number | null;
    lookup_countries_id: string | null;
    lookup_states_id: string | null;
    active: boolean;
    email: string;
    monitoring_emails: string | null;
    crypted_password: string | null;
    salt: string;
    hash: 'sha1' | 'sha3_512';
    password_updated_at: string;
    title: string | null;
    firstname: string | null;
    lastname: string | null;
    birth_year: number | null;
    phone: string | null;
    address_1: string | null;
    address_2: string | null;
    city: string | null;
    postalcode: string | null;
    activation_code: string | null;
    created_at: string;
    updated_at: string;
    delivery_fee_active: boolean;
    show_contracts: boolean;
    has_sales_access: boolean;
    sales_revenue_ratio: number | null;
    custom_revenue_ratio: number | null;
    company_name: string | null;
    payments_to: string | null;
    fax: string | null;
    fixed_cpm: number | null;
    language_id: string;
    order_prefix: string | null;
    gst_number: string | null;
    pst_number: string | null;
    show_zone_label: boolean;
    screen_id_prefix: string | null;
    site_name_prefix: string | null;
    demo_mode: boolean;
    notes: string | null;
    source: string | null;
    avatar: string | null;
    currency_id: string;
    time_zone_id: string;
    ui_settings: {
      theme: 'dark' | 'light';
      distance_unit: 'millimeters' | 'centimeters' | 'meters' | 'kilometers' | 'inches' | 'feet' | 'yards' | 'miles' | 'nauticalmiles';
    };
    account_manager_id2: number | null;
    dsp_id: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/user/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a particular user
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUser(
    id: number,
  ): CancelablePromise<{
    id: number;
    agency_id: number | null;
    account_manager_id: number | null;
    analyst_id: number | null;
    lookup_countries_id: string | null;
    lookup_states_id: string | null;
    active: boolean;
    email: string;
    monitoring_emails: string | null;
    crypted_password: string | null;
    salt: string;
    hash: 'sha1' | 'sha3_512';
    password_updated_at: string;
    title: string | null;
    firstname: string | null;
    lastname: string | null;
    birth_year: number | null;
    phone: string | null;
    address_1: string | null;
    address_2: string | null;
    city: string | null;
    postalcode: string | null;
    activation_code: string | null;
    created_at: string;
    updated_at: string;
    delivery_fee_active: boolean;
    show_contracts: boolean;
    has_sales_access: boolean;
    sales_revenue_ratio: number | null;
    custom_revenue_ratio: number | null;
    company_name: string | null;
    payments_to: string | null;
    fax: string | null;
    fixed_cpm: number | null;
    language_id: string;
    order_prefix: string | null;
    gst_number: string | null;
    pst_number: string | null;
    show_zone_label: boolean;
    screen_id_prefix: string | null;
    site_name_prefix: string | null;
    demo_mode: boolean;
    notes: string | null;
    source: string | null;
    avatar: string | null;
    currency_id: string;
    time_zone_id: string;
    ui_settings: {
      theme: 'dark' | 'light';
      distance_unit: 'millimeters' | 'centimeters' | 'meters' | 'kilometers' | 'inches' | 'feet' | 'yards' | 'miles' | 'nauticalmiles';
    };
    account_manager_id2: number | null;
    dsp_id: number | null;
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns available impersonators for a user (those he can choose to impersonate)
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUserAvailableImpersonatorList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    user_id: number;
    impersonator_id: number;
    start_date: string | null;
    end_date: string | null;
    created_at: string;
    updated_at: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/{id}/available-impersonator/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns current impersonators for a user (those he chose to impersonate himself)
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUserImpersonatorList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    user_id: number;
    impersonator_id: number;
    start_date: string | null;
    end_date: string | null;
    created_at: string;
    updated_at: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/{id}/impersonator/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that deletes a particular representative for a user
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiUserRepresentative(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    user_id: number;
    representative_id: number;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/user/{id}/representative',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that returns a list of user representatives
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUserRepresentative(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    user_id: number;
    representative_id: number;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/{id}/representative',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that deletes a particular role for a user
   * @param id
   * @param role
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiUserRole(
    id: number,
    role: 'admin' | 'accounts.partners' | 'publisher' | 'operator' | 'representative' | 'accounts.agencies' | 'direct.agency.buyer' | 'direct.agency.reporter' | 'direct.agency.publisher' | 'accounts.programmatic' | 'direct.agency.dooh_publisher' | 'analyst' | 'operator.dooh' | 'operator.rtb' | 'public' | 'dsp.user' | 'operator.guaranteed_pricing' | 'dsp.admin' | 'dsp.sale' | 'dsp.reports' | 'ssp.user' | 'ssp.admin',
  ): CancelablePromise<{
    user_id: number;
    role: 'admin' | 'accounts.partners' | 'publisher' | 'operator' | 'representative' | 'accounts.agencies' | 'direct.agency.buyer' | 'direct.agency.reporter' | 'direct.agency.publisher' | 'accounts.programmatic' | 'direct.agency.dooh_publisher' | 'analyst' | 'operator.dooh' | 'operator.rtb' | 'public' | 'dsp.user' | 'operator.guaranteed_pricing' | 'dsp.admin' | 'dsp.sale' | 'dsp.reports' | 'ssp.user' | 'ssp.admin';
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/user/{id}/role/{role}',
      path: {
        'id': id,
        'role': role,
      },
    });
  }

  /**
   * Method that returns current roles for a user
   * @param id
   * @returns string Default Response
   * @throws ApiError
   */
  public static getApiUserRoleList(
    id: number,
  ): CancelablePromise<Array<'admin' | 'accounts.partners' | 'publisher' | 'operator' | 'representative' | 'accounts.agencies' | 'direct.agency.buyer' | 'direct.agency.reporter' | 'direct.agency.publisher' | 'accounts.programmatic' | 'direct.agency.dooh_publisher' | 'analyst' | 'operator.dooh' | 'operator.rtb' | 'public' | 'dsp.user' | 'operator.guaranteed_pricing' | 'dsp.admin' | 'dsp.sale' | 'dsp.reports' | 'ssp.user' | 'ssp.admin'>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/{id}/role/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns current sites for a user
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUserSiteList(
    id: number,
  ): CancelablePromise<Array<{
    id?: number;
    user_id?: number | null;
    name?: string;
    url?: string;
    status_id?: 'active' | 'approved' | 'inactive' | 'pending' | 'refused';
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/{id}/site/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns the list of tags for a particular user
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUserTagList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    user_id: number;
    name: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/{id}/tag/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that deletes a particular impersonator for a user
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiUserImpersonator(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    user_id: number;
    impersonator_id: number;
    start_date: string | null;
    end_date: string | null;
    created_at: string;
    updated_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/user/{id1}/impersonator/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a tag for a particular user
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiUserTag(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    user_id: number;
    name: string;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/user/{id1}/tag/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that creates a new adstanding user
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiUserSignup(
    requestBody: {
      email: string;
      firstname: string | null;
      lastname: string | null;
      country: string;
      state: string;
      agency_name: string;
      language: 'en' | 'es' | 'fr' | 'ar';
      agency_language: string;
      agency_currency: string;
      phone: string | null;
      password?: string;
      'g-recaptcha-response': string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/signup',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a new adstanding user
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiUserAdstanding(
    requestBody: {
      email: string;
      firstname: string | null;
      lastname: string | null;
      country: string;
      state: string;
      agency_name: string;
      language: 'en' | 'es' | 'fr' | 'ar';
      agency_language: string;
      agency_currency: string;
      phone: string | null;
      password?: string;
      'g-recaptcha-response': string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/adstanding',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a particular user
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiUserResetPasswordDemand(
    requestBody: {
      email: string;
      'g-recaptcha-response': string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/reset-password-demand',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a particular user
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiUserResetPassword(
    requestBody: {
      email: string;
      code: string;
      password: string;
      'g-recaptcha-response': string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/reset-password',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a particular user
   * @param email
   * @param code
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUserSignupConfirmEmail(
    email: string,
    code: string,
  ): CancelablePromise<{
    id: number;
    agency_id: number | null;
    account_manager_id: number | null;
    analyst_id: number | null;
    lookup_countries_id: string | null;
    lookup_states_id: string | null;
    active: boolean;
    email: string;
    monitoring_emails: string | null;
    crypted_password: string | null;
    salt: string;
    hash: 'sha1' | 'sha3_512';
    password_updated_at: string;
    title: string | null;
    firstname: string | null;
    lastname: string | null;
    birth_year: number | null;
    phone: string | null;
    address_1: string | null;
    address_2: string | null;
    city: string | null;
    postalcode: string | null;
    activation_code: string | null;
    created_at: string;
    updated_at: string;
    delivery_fee_active: boolean;
    show_contracts: boolean;
    has_sales_access: boolean;
    sales_revenue_ratio: number | null;
    custom_revenue_ratio: number | null;
    company_name: string | null;
    payments_to: string | null;
    fax: string | null;
    fixed_cpm: number | null;
    language_id: string;
    order_prefix: string | null;
    gst_number: string | null;
    pst_number: string | null;
    show_zone_label: boolean;
    screen_id_prefix: string | null;
    site_name_prefix: string | null;
    demo_mode: boolean;
    notes: string | null;
    source: string | null;
    avatar: string | null;
    currency_id: string;
    time_zone_id: string;
    ui_settings: {
      theme: 'dark' | 'light';
      distance_unit: 'millimeters' | 'centimeters' | 'meters' | 'kilometers' | 'inches' | 'feet' | 'yards' | 'miles' | 'nauticalmiles';
    };
    account_manager_id2: number | null;
    dsp_id: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/signup/confirm-email/{email}/{code}',
      path: {
        'email': email,
        'code': code,
      },
    });
  }

  /**
   * Method that returns a particular user
   * @param email
   * @param code
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUserAdstandingConfirmEmail(
    email: string,
    code: string,
  ): CancelablePromise<{
    id: number;
    agency_id: number | null;
    account_manager_id: number | null;
    analyst_id: number | null;
    lookup_countries_id: string | null;
    lookup_states_id: string | null;
    active: boolean;
    email: string;
    monitoring_emails: string | null;
    crypted_password: string | null;
    salt: string;
    hash: 'sha1' | 'sha3_512';
    password_updated_at: string;
    title: string | null;
    firstname: string | null;
    lastname: string | null;
    birth_year: number | null;
    phone: string | null;
    address_1: string | null;
    address_2: string | null;
    city: string | null;
    postalcode: string | null;
    activation_code: string | null;
    created_at: string;
    updated_at: string;
    delivery_fee_active: boolean;
    show_contracts: boolean;
    has_sales_access: boolean;
    sales_revenue_ratio: number | null;
    custom_revenue_ratio: number | null;
    company_name: string | null;
    payments_to: string | null;
    fax: string | null;
    fixed_cpm: number | null;
    language_id: string;
    order_prefix: string | null;
    gst_number: string | null;
    pst_number: string | null;
    show_zone_label: boolean;
    screen_id_prefix: string | null;
    site_name_prefix: string | null;
    demo_mode: boolean;
    notes: string | null;
    source: string | null;
    avatar: string | null;
    currency_id: string;
    time_zone_id: string;
    ui_settings: {
      theme: 'dark' | 'light';
      distance_unit: 'millimeters' | 'centimeters' | 'meters' | 'kilometers' | 'inches' | 'feet' | 'yards' | 'miles' | 'nauticalmiles';
    };
    account_manager_id2: number | null;
    dsp_id: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/adstanding/confirm-email/{email}/{code}',
      path: {
        'email': email,
        'code': code,
      },
    });
  }

  /**
   * Method that create a impersonator for a user
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiUserImpersonator(
    requestBody: {
      id?: number;
      user_id: number;
      impersonator_id: number;
      start_date?: string | null;
      end_date?: string | null;
      created_at?: string;
      updated_at?: string;
    },
  ): CancelablePromise<{
    id: number;
    user_id: number;
    impersonator_id: number;
    start_date: string | null;
    end_date: string | null;
    created_at: string;
    updated_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/impersonator',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a impersonator for a particular user
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiUserImpersonator(
    requestBody: {
      id: number;
      user_id?: number;
      impersonator_id?: number;
      start_date?: string | null;
      end_date?: string | null;
      created_at?: string;
      updated_at?: string;
    },
  ): CancelablePromise<{
    id: number;
    user_id: number;
    impersonator_id: number;
    start_date: string | null;
    end_date: string | null;
    created_at: string;
    updated_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/user/impersonator',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns the list of users
   * @param role
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param status
   * @param agencyId
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUserList(
    role: Array<'admin' | 'accounts.partners' | 'publisher' | 'operator' | 'representative' | 'accounts.agencies' | 'direct.agency.buyer' | 'direct.agency.reporter' | 'direct.agency.publisher' | 'accounts.programmatic' | 'direct.agency.dooh_publisher' | 'analyst' | 'operator.dooh' | 'operator.rtb' | 'public' | 'dsp.user' | 'operator.guaranteed_pricing' | 'dsp.admin' | 'dsp.sale' | 'dsp.reports' | 'ssp.user' | 'ssp.admin'>,
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    status?: 'active_advertiser' | 'active_publisher' | 'agency',
    agencyId?: number,
  ): CancelablePromise<Array<{
    id: number;
    agency_id: number | null;
    account_manager_id: number | null;
    analyst_id: number | null;
    lookup_countries_id: string | null;
    lookup_states_id: string | null;
    active: boolean;
    email: string;
    monitoring_emails: string | null;
    crypted_password: string | null;
    salt: string;
    hash: 'sha1' | 'sha3_512';
    password_updated_at: string;
    title: string | null;
    firstname: string | null;
    lastname: string | null;
    birth_year: number | null;
    phone: string | null;
    address_1: string | null;
    address_2: string | null;
    city: string | null;
    postalcode: string | null;
    activation_code: string | null;
    created_at: string;
    updated_at: string;
    delivery_fee_active: boolean;
    show_contracts: boolean;
    has_sales_access: boolean;
    sales_revenue_ratio: number | null;
    custom_revenue_ratio: number | null;
    company_name: string | null;
    payments_to: string | null;
    fax: string | null;
    fixed_cpm: number | null;
    language_id: string;
    order_prefix: string | null;
    gst_number: string | null;
    pst_number: string | null;
    show_zone_label: boolean;
    screen_id_prefix: string | null;
    site_name_prefix: string | null;
    demo_mode: boolean;
    notes: string | null;
    source: string | null;
    avatar: string | null;
    currency_id: string;
    time_zone_id: string;
    ui_settings: {
      theme: 'dark' | 'light';
      distance_unit: 'millimeters' | 'centimeters' | 'meters' | 'kilometers' | 'inches' | 'feet' | 'yards' | 'miles' | 'nauticalmiles';
    };
    account_manager_id2: number | null;
    dsp_id: number | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'status': status,
        'agency_id': agencyId,
        'role': role,
      },
    });
  }

  /**
   * Method that create a representative for a user
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiUserRepresentative(
    id: number,
    requestBody: {
      id?: number;
      user_id: number;
      representative_id: number;
    },
  ): CancelablePromise<{
    id: number;
    user_id: number;
    representative_id: number;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/representative',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that create a role for a user
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiUserRole(
    requestBody: {
      user_id: number;
      role: 'admin' | 'accounts.partners' | 'publisher' | 'operator' | 'representative' | 'accounts.agencies' | 'direct.agency.buyer' | 'direct.agency.reporter' | 'direct.agency.publisher' | 'accounts.programmatic' | 'direct.agency.dooh_publisher' | 'analyst' | 'operator.dooh' | 'operator.rtb' | 'public' | 'dsp.user' | 'operator.guaranteed_pricing' | 'dsp.admin' | 'dsp.sale' | 'dsp.reports' | 'ssp.user' | 'ssp.admin';
    },
  ): CancelablePromise<{
    user_id: number;
    role: 'admin' | 'accounts.partners' | 'publisher' | 'operator' | 'representative' | 'accounts.agencies' | 'direct.agency.buyer' | 'direct.agency.reporter' | 'direct.agency.publisher' | 'accounts.programmatic' | 'direct.agency.dooh_publisher' | 'analyst' | 'operator.dooh' | 'operator.rtb' | 'public' | 'dsp.user' | 'operator.guaranteed_pricing' | 'dsp.admin' | 'dsp.sale' | 'dsp.reports' | 'ssp.user' | 'ssp.admin';
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/role',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns available roles
   * @returns string Default Response
   * @throws ApiError
   */
  public static getApiUserRoleList1(): CancelablePromise<Array<'admin' | 'accounts.partners' | 'publisher' | 'operator' | 'representative' | 'accounts.agencies' | 'direct.agency.buyer' | 'direct.agency.reporter' | 'direct.agency.publisher' | 'accounts.programmatic' | 'direct.agency.dooh_publisher' | 'analyst' | 'operator.dooh' | 'operator.rtb' | 'public' | 'dsp.user' | 'operator.guaranteed_pricing' | 'dsp.admin' | 'dsp.sale' | 'dsp.reports' | 'ssp.user' | 'ssp.admin'>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/role/list',
    });
  }

  /**
   * Method that creates a new tag for a particular user
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiUserTag(
    requestBody: {
      id?: number;
      user_id: number;
      name: string;
    },
  ): CancelablePromise<{
    id: number;
    user_id: number;
    name: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/tag',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a tag for a particular user
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiUserTag(
    requestBody: {
      id: number;
      user_id?: number;
      name?: string;
    },
  ): CancelablePromise<{
    id: number;
    user_id: number;
    name: string;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/user/tag',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
